<template>
    <Card :title="$t('labels.client')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')" :required="true">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="client.name"
                            :query-params="{
                                orders: [
                                    { column: 'name', dir: 'asc'}
                                ]
                            }"
                            @update:modelValue="client.name = $event"
                            @select="handleSelection"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.phone || option.email }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.email')">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="client.email"
                            :query-params="{
                                orders: [
                                    { column: 'email', dir: 'asc'}
                                ]
                            }"
                            option-value="email"
                            @update:modelValue="client.email = $event"
                            @select="handleSelection"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.email }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.phone')">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="client.phone"
                            :query-params="{
                                orders: [
                                    { column: 'phone', dir: 'asc'}
                                ]
                            }"
                            option-value="phone"
                            @update:modelValue="client.phone = $event"
                            @select="handleSelection"
                            mask="+38 (###) ###-##-##"
                            placeholder="+38 (999) 999-99-99"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.phone }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="light" class="mr-2" @click="remove">
                <i class="icon-trash mr-2"></i>
                {{ $t('buttons.delete') }}
            </Button>
            <Button color="indigo" @click="edit">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.edit') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import InputAutoComplete from "../../../../../components/new/form/autocomplete/InputAutoComplete.vue";
import Button from "../../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: 'MainInformationCard',
    components: {
        Card, FormGroup, InputAutoComplete, Button
    },
    emits: ['update:client'],
    props: {
        client: {
            type: Object,
            required: true
        }
    },
    methods: {
        handleSelection(option) {
            this.$router.push({
                name: 'ClientEditPage',
                params: {
                    clientUuid: option.uuid
                }
            });
            this.$emit('update:client', option.uuid);
        },
        async edit() {
            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/clients/${this.$route.params.clientUuid}`, {
                name: this.client.name,
                email: this.client.email,
                phone: this.client.phone
            }).then((response) => {
                new MessageNotificator().success(this.$t("alerts.success"))
                this.$emit('update:client', response.data.data)
            })
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.client')
            }), async () => {
                await httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/clients/${this.$route.params.clientUuid}`).then(() => {
                    this.$router.push({name: "ClientsIndexPage"})
                })
            })
        }
    }
}
</script>